import React, { useState, useEffect } from "react";
import "./AdminGreetings.css";

import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState } from "draft-js";
import { convertToHTML } from "draft-convert";
import axios from "axios";
import swal from "sweetalert";

const LiveChatProfileCreate = () => {
  const [greetingInput, setGreeting] = useState({
    title: "",
    star_id: "",
    cost: "",
    star_time: "",
    end_time: "",
    error_list: [],
  });

  const [file, setFile] = useState("");
  const [imagedata, setImagedata] = useState("");

  const handleInput = (e) => {
    e.persist();
    setGreeting({ ...greetingInput, [e.target.name]: e.target.value });
  };

  const handleChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setImagedata(file[0]);
  };

  // Editor Funtionalities //
  const [convertedContent, setConvertedContent] = useState(null);

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  const handleEditorChange = (state) => {
    setEditorState(state);
    convertContentToHTML();
  };

  const convertContentToHTML = () => {
    let currentContentAsHTML = convertToHTML(editorState.getCurrentContent());
    setConvertedContent(currentContentAsHTML);
  };
  // End Editor Functionalies //

  const greetingSubmit = (e) => {
    e.preventDefault();

    const fData = new FormData();

    fData.append("banner", imagedata);
    fData.append("star_id", greetingInput.star_id);
    fData.append("title", greetingInput.title);
    fData.append("cost", greetingInput.cost);
    fData.append("description", convertedContent);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/admin/add_livechat_profile`, fData).then((res) => {
        if (res.data.status === 200) {
          //document.getElementById('input_form').reset();
          swal("Success", res.data.message, "success");

          //window.location.href = "/superstar-admin/superstars";
          //setModalShow(false);
        } else {
          //setModalShow(true);
          setGreeting({
            ...greetingInput,
            error_list: res.data.validation_errors,
          });
        }
      });
    });
  };

  return (
    <div className="">
      <div className="text-light border border-warning rounded-3 d-flex justify-content-center px-2 pb-2 mb-3">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus"></i>
        </div>
        <h4 className="mx-3 text-warning p-2">Create Live Session Event</h4>
      </div>
      <div className="greetingsPadding row bg-dark">
        <div className="row">
          <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
            <form
              onSubmit={greetingSubmit}
              id="input_form"
              encType="multipart/form-data"
            >
              <div className="row my-4">
                <div className="col-md-3 text-warning">
                  <p>
                    <big>Title</big>
                  </p>
                </div>
                <div className="col-md-9">
                  <input
                    className="form-control reply-control"
                    type="text"
                    onChange={handleInput}
                    name="title"
                    value={greetingInput.title}
                  />
                </div>
              </div>

              <div className="row my-4">
                <div className="col-md-3 text-warning">
                  <p>
                    <big>Description</big>
                  </p>
                </div>
                <div className="col-md-9">
                  <Editor
                    editorState={editorState}
                    onEditorStateChange={handleEditorChange}
                    wrapperClassName="wrapper-class"
                    editorClassName="editor-class"
                    toolbarClassName="toolbar-class"
                  />
                </div>
              </div>
              <div className="row my-4">
                <div className="col-md-3 text-warning">
                  <p>
                    <big>Cost</big>
                  </p>
                </div>
                <div className="col-md-9">
                  <input
                    className="form-control reply-control"
                    type="number"
                    onChange={handleInput}
                    name="cost"
                    value={greetingInput.cost}
                  />
                </div>
              </div>

              <div className="row my-4">
                <div className="col-md-3 text-warning">
                  <p>
                    <big>Upload Banner</big>
                  </p>
                </div>
                <div className="col-md-9">
                  {/* <input
                type="file"
                onChange={(e) => handleChange(e.target.files)}
                id="image"
                name="image"
                className="inputfile"
                />
                <label for="file">
                <i className="fas fa-cloud-upload-alt"></i> Upload
                </label> */}

                  <img src={file} className="img-fluid avatar-img-src" alt="" />
                  <input
                    type="file"
                    className="reply-control"
                    onChange={(e) => handleChange(e.target.files)}
                    id="image"
                    name="image"
                  />
                </div>
              </div>

              <div className="row my-4">
                <div className="col-md-3 text-warning">
                  <p>
                    <big>Upload Video</big>
                  </p>
                </div>
                <div className="col-md-5">
                  <input
                    type="file"
                    name="file"
                    id="file"
                    className="inputfile"
                  />
                  <label for="file">
                    <i className="fas fa-cloud-upload-alt"></i> Upload
                  </label>
                </div>
              </div>

              <div className="my-3 row">
                <div className="col-md-3 mx-auto">
                  <button type="submit" className="btn btnSave w-100 fw-bold">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveChatProfileCreate;
